import {
    Box,
    Button,
    CircularProgress,
    Divider,
    Grid,
    InputAdornment,
    TextField,
    Typography,
} from "@mui/material";
import { useState } from "react";
import { NumericFormatCustom } from "components/inputs/custom-numeric-input";
import { useCustom } from "@refinedev/core";
import { useNavigate, useParams } from "react-router-dom";
import { primary } from "style/color";
import { Show } from "@refinedev/mui";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { GvDistributionConfirmationModal } from "components/modal/gv-distribution-modal-confirmation";

interface ModalProps { }

export const GrantVestmentDistribution: React.FC<ModalProps> = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [amount, setAmount] = useState({ value: 0, error: false });
    const [comment, setComment] = useState({ value: "", error: false });
    const date = new Date().toISOString().substring(0, 10);
    const [distributionDate, setDistributionDate] = useState({
        value: date,
        error: false,
    });
    const [referenceDate, setReferenceDate] = useState({
        value: date,
        error: false,
    });
    const { data: grantvestment } = useCustom({
        url: `grant-vestments/${id}`,
        method: "get",

    });
    const { data, isLoading } = useCustom({
        url: `total-grantvestments/${id}`,
        method: "get",
        config: {
            filters: [
                {
                    field: 'date',
                    operator: "eq",
                    value: referenceDate.value,
                },
            ],
        },

    });
    const [open, setOpen] = useState(false);


    return (
        <Show
            goBack={
                <Button onClick={() => navigate(-1)}>
                    <ArrowBackIcon />
                </Button>
            }
            title={
                <Typography variant="h5" color={primary}>
                    Add Distribution for {grantvestment?.data.name}{" "}
                </Typography>
            }
        >
            {isLoading ? (
                <CircularProgress />
            ) : (
                <Box sx={{ bgcolor: "background.paper" }}>
                    <Divider />


                    <Typography pt={1}>
                        Please add the amount
                    </Typography>
                    <TextField
                        value={amount.value || 0}
                        error={amount.error}
                        helperText={amount.error && "The amount is required!"}
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">$</InputAdornment>
                            ),
                            inputComponent: NumericFormatCustom as any,
                        }}
                        onChange={(e) =>
                            setAmount({ value: parseFloat(e.target.value), error: false })
                        }
                        label={"Amount"}
                        name="amount"
                    />
                    <Typography pt={1}>
                        Please add a comment
                    </Typography>
                    <TextField
                        value={comment.value || ""}
                        margin="normal"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                        onChange={(e) =>
                            setComment({ value: e.target.value, error: false })
                        }
                        label={"Comment"}
                        name="comment"
                    />


                    <Typography pt={2}>
                        Please add the reference  date
                    </Typography>
                    <Grid item xs={12}>
                        <TextField
                            id="referenceDate"
                            error={referenceDate.error}
                            helperText={
                                referenceDate.error &&
                                "The date is required, and can not be negative value!"
                            }
                            defaultValue={referenceDate.value}
                            margin="normal"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            type="date"
                            label="Date"
                            name="referenceDate"
                            onChange={(event) => {
                                setReferenceDate({
                                    value: event.target.value,
                                    error: false,
                                });
                            }}
                        />
                    </Grid>
                    <Typography pt={2}>
                        Please add the distribution payment date
                    </Typography>
                    <Grid item xs={12}>
                        <TextField
                            id="distributionDate"
                            error={distributionDate.error}
                            helperText={
                                distributionDate.error &&
                                "The date is required, and can not be negative value!"
                            }
                            defaultValue={distributionDate.value}
                            margin="normal"
                            fullWidth
                            InputLabelProps={{ shrink: true }}
                            type="date"
                            label="Date"
                            name="distributionDate"
                            onChange={(event) => {
                                setDistributionDate({
                                    value: event.target.value,
                                    error: false,
                                });
                            }}
                        />
                    </Grid>

                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "row",

                            justifyContent: "flex-end",
                            marginTop: 3,
                        }}
                    >
                        <Button
                            variant="contained"
                            disabled={
                                amount.value === 0 ||
                                isLoading ||
                                open
                            }
                            startIcon={
                                isLoading && <CircularProgress size={20} color="inherit" />
                            }
                            onClick={(e) => {
                                if (amount.value === 0 || !amount.value) {
                                    setAmount({ ...amount, error: true });
                                }
                                if (!distributionDate.value) {
                                    setDistributionDate({ ...distributionDate, error: true });
                                }

                                if (
                                    !amount.error &&
                                    !distributionDate.error
                                ) {
                                    setOpen(true);
                                }
                            }}
                        >
                            Confirm
                        </Button>
                    </Box>
                </Box>
            )}
            <GvDistributionConfirmationModal
                open={open}
                setOpen={setOpen}
                id={+id!}
                name={grantvestment?.data.name}
                amount={amount.value}
                comment={comment.value}
                data={data?.data.funds}
                distributionDate={distributionDate.value}
                referenceDate={referenceDate.value}
            />
        </Show>
    );
};
